export const LoadingIndicator = () => (
  <div className="example-inner">
    <div className="d-flex align-items-center justify-content-center h-100">
      <div className="loading-indicator">
        <span className="visually-hidden">Загрузка…</span>
      </div>
    </div>
  </div>
);
